import { render, staticRenderFns } from "./PhoneValidation.vue?vue&type=template&id=7d32a22a&scoped=true&"
import script from "./PhoneValidation.vue?vue&type=script&lang=js&"
export * from "./PhoneValidation.vue?vue&type=script&lang=js&"
import style0 from "./PhoneValidation.vue?vue&type=style&index=0&id=7d32a22a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d32a22a",
  null
  
)

export default component.exports